<template>
    <div class="tankuang" v-show="bool">
        <div class="tiaokuang">

        </div>
        <div class="title">
            《河南省全科医学培训中心购买条款》<span class="span" @click="show()" >+</span>
        </div>
        <div class="div">
            <div v-html="html">

            </div>
        </div>
    </div>
</template>
<script>
import qs from 'qs'
export default {
    name:'tankuang',
    data(){
        return{
           
           html:'',
           bool:true
        }
    },
    mounted(){
        let that = this
        var data = {
            mark:'goumaitiaokuan'
        }
        this.$axios.post('/html/index',qs.stringify(data)).then( res => {
            //console.log(res.data);
            this.html = res.data.data.contents
        })
    },
    methods:{
        show(){
            this.bool = !this.bool
        }
    }
}
</script>
<style lang="less" scoped>
    .tiaokuang{
        height: 100%;
        width: 100%;
        background: #000;
        position: fixed;
        top: 0;
        left: 0;
        opacity: 0.5;
    }
    .div{
        height: 800px;
        width: 800px;
        background: #fff;
        opacity:1;
        padding: 100px 20px 20px;
        line-height: 30px;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        overflow-y:auto;
        overflow-x:auto;
    }
    .title{
        height: 70px;
        line-height: 70px;
        width: 800px;
        text-align: center;
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin:0 auto;
        z-index: 100;
        background: #fff;
    }
    .span{
        font-size:30px;
        transform:rotate(45deg);
        float: right;
        margin-top: -20px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/tankuang.vue